// src/components/HaircutGallery.jsx
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

// Example image imports (replace with your actual images)
import cut1 from '../assets/cuts/cut1.jpg';
import cut2 from '../assets/cuts/cut2.png';
import cut3 from '../assets/cuts/cut3.jpg';
import cut4 from '../assets/cuts/cut4.png';
import cut5 from '../assets/cuts/cut5.png';
import cut6 from '../assets/cuts/cut6.jpg';

const haircutImages = [cut1, cut2, cut3, cut4, cut5, cut6];

const HaircutGallery = () => {
  return (
    <section style={{ backgroundColor: '#000', padding: '4rem 0' }}>
      <Container>
        <h2 className="text-white text-center mb-5 display-5">
          Alguns de nossos trabalhos:
        </h2>
        <Row className="g-4">
          {haircutImages.map((src, index) => (
            <Col xs={12} sm={6} md={4} key={index}>
              <div style={{ overflow: 'hidden', borderRadius: '12px' }}>
                <img
                  src={src}
                  alt={`Haircut ${index + 1}`}
                  style={{
                    width: '100%',
                    height: 'auto',
                    display: 'block',
                    transition: 'transform 0.3s ease',
                  }}
                  className="hover-zoom"
                />
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default HaircutGallery;
